import { gql } from '@apollo/client'

export const CHECK_STATUS_QUERY = gql`
  query CheckStatus($reservationNumber: String!) {
    checkStatus(reservationNumber: $reservationNumber) {
      reservationNumber
      pmsType
      rooms {
        crsNumber
        displayCrsNumber
        pmsNumber
        pmsStatus
      }
    }
  }
`
